import React, { useState } from "react";
import { Grid, Paper } from "@material-ui/core";

import Chart from "react-apexcharts";
import { SEX } from "../../../utils/constants";
import { stateChart } from "../../../utils/stateChart";
import styled from "styled-components";

const initialState = stateChart(["HOMBRES", "MUJERES"]);

const ReportBySex = ({ data }) => {
  const [state] = useState(initialState);

  const quantityResearchersBySex = (sex) => {
    const res = data.filter((researcher) => researcher.sex === sex);
    return res.length;
  };

  return (
    <Grid item xs={12} sm={12} md={6} lg={4}>
      <Paper className="paper" style={{ marginTop: "2em" }}>
        <TitlePaper>Investigadores por Género</TitlePaper>
        <Chart
          options={state.options}
          series={[
            quantityResearchersBySex(SEX.HOMBRE),
            quantityResearchersBySex(SEX.MUJER),
          ]}
          type="pie"
          height={380}
          className="chart"
        />
      </Paper>
    </Grid>
  );
};

const TitlePaper = styled.h3`
  margin: 0;
`;

export default ReportBySex;
